var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e;
import { inject, singleton } from "tsyringe";
import { Holidays, RArray, WeeklySchedule } from "../collections";
import { RestaurantId, makeImmutable } from "../core";
import { CheckoutInfoService, HolidayService, IQrWaiter, OrderingAvailabilityService, RestaumaticRPCService, } from "../services";
import { OnlineOrderingHours, QrWaiterOrderingHours, } from "./OrderingHours";
import { Sentry } from "../Sentry";
let BackendDataService = class BackendDataService {
    constructor(rpcService, checkoutInfoService, holidayService, orderingAvailabilityService, qrWaiter) {
        this.rpcService = rpcService;
        this.checkoutInfoService = checkoutInfoService;
        this.holidayService = holidayService;
        this.orderingAvailabilityService = orderingAvailabilityService;
        this.qrWaiter = qrWaiter;
        makeImmutable(this);
    }
    async getBackendData(params) {
        const restaurantId = new RestaurantId(params.restaurantId);
        const requests = Promise.all([
            // menuResponse
            params.menuResponse,
            // dineInLocation
            this.getDineInLocation(restaurantId),
            // orderingAvailability
            this.orderingAvailabilityService.getOrderingAvailability(restaurantId),
            // checkoutInfo
            this.checkoutInfoService.getCheckoutInfo(restaurantId),
            // payment channels
            params.fetchPaymentChannels
                ? this.checkoutInfoService.getPaymentChannels(restaurantId)
                : Promise.resolve(RArray.empty()),
            // automaticCrossSellingWeights
            this.rpcService.rpc("GetAcsWeights", {
                restaurantId: restaurantId.value,
            }),
            // holidays (raw; the Holidays collection is built below once we have the timezone)
            this.holidayService.fetchHolidays(restaurantId),
        ]);
        const [menuResponse, dineInLocation, backendOrderingAvailability, checkoutInfo, paymentChannels, automaticCrossSellingWeights, holidayInfos,] = await requests;
        const orderingHours = this.orderingHours({
            weeklyAvailability: menuResponse.ordering_hours,
            holidays: Holidays.create(menuResponse.time_zone, holidayInfos),
        });
        return {
            restaurantId,
            menuResponse,
            dineInLocation,
            backendOrderingAvailability,
            checkoutInfo,
            orderingHours,
            paymentChannels,
            automaticCrossSellingWeights,
        };
    }
    async getBackendPaymentChannels(restaurantId) {
        return this.checkoutInfoService.getPaymentChannels(restaurantId);
    }
    orderingHours(params) {
        if (this.qrWaiter.isQrWaiterOrder()) {
            return new QrWaiterOrderingHours();
        }
        return new OnlineOrderingHours({
            weeklySchedule: WeeklySchedule.fromWeeklyAvailability(params.weeklyAvailability),
            holidays: params.holidays,
        });
    }
    async getDineInLocation(restaurantId) {
        const sessionDineInLocation = this.qrWaiter.getSessionDineInLocation();
        return sessionDineInLocation != null
            ? Promise.resolve(sessionDineInLocation)
            : this.searchInitialDineInLocation(restaurantId);
    }
    async searchInitialDineInLocation(restaurantId) {
        const params = this.qrWaiter.getQrWaiterParameters();
        if (!params) {
            return null;
        }
        if ("table" in params) {
            return { tag: "Table", number: params.table };
        }
        if ("areaId" in params) {
            const rpcService = new RestaumaticRPCService("");
            return rpcService
                .rpc2("GetServingAreaRequest", {
                restaurantId: restaurantId.value,
                servingAreaId: params.areaId,
            })
                .then((result) => {
                var _a;
                if (!result) {
                    Sentry.logError(new Error(`QrWaiter Serving area not found, restaurantId=${restaurantId.value}, areaId=${params.areaId}`));
                }
                return {
                    tag: "ServingLocation",
                    areaId: params.areaId,
                    areaName: (_a = result === null || result === void 0 ? void 0 : result.name) !== null && _a !== void 0 ? _a : "?",
                    pointName: params.pointName,
                };
            });
        }
        return null;
    }
};
BackendDataService = __decorate([
    singleton(),
    __param(4, inject(IQrWaiter)),
    __metadata("design:paramtypes", [typeof (_a = typeof RestaumaticRPCService !== "undefined" && RestaumaticRPCService) === "function" ? _a : Object, typeof (_b = typeof CheckoutInfoService !== "undefined" && CheckoutInfoService) === "function" ? _b : Object, typeof (_c = typeof HolidayService !== "undefined" && HolidayService) === "function" ? _c : Object, typeof (_d = typeof OrderingAvailabilityService !== "undefined" && OrderingAvailabilityService) === "function" ? _d : Object, typeof (_e = typeof IQrWaiter !== "undefined" && IQrWaiter) === "function" ? _e : Object])
], BackendDataService);
export { BackendDataService };
